// extracted by mini-css-extract-plugin
module.exports = {"selector":"style__selector__lrpRG"};